import uxinsightsicon from '../../assets/uxinsightsicon.svg';
import oneinsightsicon from '../../assets/oneinsightsicon.png';
import three from '../../assets/three.png';
import four from '../../assets/four.png';
import five from '../../assets/five.png';
import six from '../../assets/six.svg';
import seven from '../../assets/seven.png';
import eight from '../../assets/eight.png';
import nine from '../../assets/nine.svg';

const Menu = [
  {
    id: 1,
    image: oneinsightsicon,
    name: "The Importance of Responsive Web Design",
    category: "Web Development",
    description: "Join us on a journey through our vibrant studio as we unlock the power of creativity and bring dreams to reality."
  },
  {
    id: 2,
    image: uxinsightsicon,
    name: "Why User Experience Matters in Web Design",
    category: "UI/UX Design",
    description: "Join us on a journey through our vibrant studio as we unlock the power of creativity and bring dreams to reality."
  },
  {
    id: 3,
    image: three,
    name: "The Future of E-commerce: Trends and Predictions",
    category: "SEO",
    description: "Join us on a journey through our vibrant studio as we unlock the power of creativity and bring dreams to reality."
  },
  {
    id: 4,
    image: four,
    name: "The Importance of Visual Identity for Branding",
    category: "Visual Identity",
    description: "Visual identity plays a crucial role in branding as it encompasses the visual elements that represent a brand's essence."
  },
  {
    id: 5,
    image: five,
    name: "Principles of Animation bringing Life",
    category: "Animation",
    description: "The principles of animation are fundamental guidelines that bring life and movement to static images and objects"
  },
  {
    id: 6,
    image: six,
    name: "Integrating Social Media APIs in Mobile Apps",
    category: "App Development",
    description: "Integrating social media APIs in mobile apps allows users to connect and interact with social media"
  },
  {
    id: 7,
    image: seven,
    name: "Hosting Options and Deployment Strategies",
    category: "Web Development",
    description: "When it comes to hosting options and deployment strategies for web applications or websites, there are several approaches to consider."
  },
  {
    id: 8,
    image: eight,
    name: "The Fundamentals of User Interface Design",
    category: "UI/UX Design",
    description: "UI design is a critical aspect of creating intuitive and user-friendly digital products. It focuses on designing the visual elements"
  },
  {
    id: 9,
    image: nine,
    name: "SEO basics, a comprehensive guide",
    category: "SEO",
    description: "SEO (Search Engine Optimization) is the practice of optimizing a website to improve its visibility and ranking in search engine results pages."
  }
];

export default Menu;
